import * as React from 'react';
import { FormContextType } from '../../../Types/FormTypes';

// Default values will be used if a form context consumer is created outside of the scope of a form context provider
const defaultValues = {
  values: {},
  errors: {},
  warnings: {},
  touched: {},
  isSubmitting: false,
  isValidating: false,

  setErrors: () => {},
  setWarnings: () => {},
  setSubmitting: () => {},
  setTouched: () => {},
  setValues: () => {},
  setFieldValue: () => {},
  setFieldErrors: () => {},
  setFieldWarnings: () => {},
  setFieldTouched: () => {},
  validateForm: () => {},
  validateField: () => {},
  resetForm: () => {},
  submitForm: () => {},
  setFormState: () => {},

  dirty: false,
  isValid: true,
  initialValues: {},

  registerField: () => {},
  unregisterField: () => {},
  handleBlur: () => {},
  handleChange: () => {},
  handleReset: () => {},
  validateOnChange: true,
  validateOnBlur: true,
};

const FormContext = React.createContext<FormContextType>(defaultValues);

export default FormContext;
